// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.read-grid .cell {
  border: 1px solid #ccc;
}

.read-grid .last-saved-date {
  font-size: 12px;
  font-weight: 300;
  color: #888;

  justify-content: flex-end;
  align-items: center;
  display: flex;
  padding: 0 5px;
}

.read-grid .unsaved-changes-indicator {
  background: #01a166;
  height: 8px;
  width: 8px;
  border-radius: 4px;
  margin: 0 5px;
  display: inline-block;
}

.read-grid .unsaved-changed-indicator.warn {
  background: red;
}

.read-grid-cell {
  box-shadow: 0 0 0 0.5px var(--table-border-color) inset;
  word-break: break-all;
  padding: 3px;
  display: flex;
  align-items: center;
  background-color: white;
  overflow: hidden;
  user-select: none;
}

.read-grid tr:last-child(td) {
  border-right: none;
}

.read-grid-cell.error {
  background-color: var(--dataTableCell-error-bgColor);
  box-shadow: 0 0 0 0.5px var(--dataTableCell-error-borderColor) inset;
  border-left: 3px solid var(--dataTableCell-error-borderColor);
}

.read-grid-cell.error[data-nth-row-type='even'] {
  background-color: var(--dataTableCell-error-bgColor-even);
}

.read-grid-cell.warning {
  background-color: var(--dataTableCell-warning-bgColor);
  box-shadow: 0 0 0 0.5px var(--dataTableCell-warning-borderColor) inset;
  border-left: 3px solid var(--dataTableCell-warning-borderColor);
}

.read-grid-cell.warning[data-nth-row-type='even'] {
  background-color: var(--dataTableCell-warning-bgColor-even);
}

.read-grid-cell.disabled {
  color: #7e7e7e;
  background-color: #e0e0e0;
  box-shadow: 0 0 0 0.5px #bfbfbf inset;
}

.read-grid-cell.disabled[data-nth-row-type='even'] {
  color: #828282;
  background-color: #d1d1d1;
  box-shadow: 0 0 0 0.5px #bfbfbf inset;
}

.read-grid-cell.error.selected {
  border-left: 3px solid var(--dataTableCell-error-borderColor);
  box-shadow: 0 0 0 1px var(--dataTableCell-error-borderColor) inset;
}

.read-grid-cell.warning.selected {
  border-left: 3px solid var(--dataTableCell-warning-borderColor);
  box-shadow: 0 0 0 1px var(--dataTableCell-warning-borderColor) inset;
}

.read-grid-cell.error.selected[data-nth-row-type='even'] {
  border-left: 3px solid var(--dataTableCell-error-borderColor);
  box-shadow: 0 0 0 1px var(--dataTableCell-error-borderColor) inset;
}

.read-grid-cell.warning.selected[data-nth-row-type='even'] {
  border-left: 3px solid var(--dataTableCell-warning-borderColor);
  box-shadow: 0 0 0 1px var(--dataTableCell-warning-borderColor) inset;
}

.read-grid-cell.selected {
  background-color: var(--dataTableCell-selected-bgColor);
  box-shadow: 0 0 0 0.5px var(--dataTableCell-selected-borderColor) inset;
  border-left: none;
}

.read-grid-cell[data-nth-row-type='even'],
.read-grid-cell[data-nth-row-type='odd-property'] {
  background-color: var(--table-even-row-bgColor);
}

.read-grid-cell.selected[data-nth-row-type='even'],
.read-grid-cell.selected[data-nth-row-type='odd-property'] {
  background-color: var(--table-active-highlight-even-td-bgColor);
  box-shadow: 0 0 0 0.5px var(--dataTableCell-selected-borderColor) inset;
}

.read-grid-cell[data-nth-row-type='even-property'] {
  background-color: var(--table-property-row-bgColor);
}

.read-grid-cell.selected[data-nth-row-type='even-property'] {
  background-color: var(--table-active-highlight-property-td-bgColor);
  box-shadow: 0 0 0 0.5px var(--table-active-highlight-property-td-borderColor) inset;
}

.read-grid-cell.selected.first-selected {
  border: 1.5px solid var(--dataTableCell-firstSelected);
}

.read-grid-cell.error.selected.first-selected {
  border-left: 3px solid var(--dataTableCell-error-borderColor);
  box-shadow: 0 0 0 1px var(--dataTableCell-error-borderColor) inset;
}

.read-grid-cell.warning.selected.first-selected {
  border-left: 3px solid var(--dataTableCell-warning-borderColor);
  box-shadow: 0 0 0 1px var(--dataTableCell-warning-borderColor) inset;
}

.read-grid-cell.error.selected.first-selected[data-nth-row-type='even'] {
  border-left: 3px solid var(--dataTableCell-error-borderColor);
  box-shadow: 0 0 0 1px var(--dataTableCell-error-borderColor) inset;
}

.read-grid-cell.warning.selected.first-selected[data-nth-row-type='even'] {
  border-left: 3px solid var(--dataTableCell-warning-borderColor);
  box-shadow: 0 0 0 1px var(--dataTableCell-warning-borderColor) inset;
}

.read-grid-cell.header {
  background-color: var(--table-th-bgcolor);
  display: flex;
}

.read-grid-cell.select-all-cell {
  background: #f4f4f4;
}

.read-grid-cell.row-num-cell {
  justify-content: center;
  background: #f4f4f4;
}

.read-grid-cell.header div {
  flex: 1;
  text-align: right;
}

.clickable {
  cursor: pointer;
}

.ReactVirtualized__Grid {
  outline: none;
}

/* hide the scrollbars on fixed rows */
.gridBottomLeft::-webkit-scrollbar,
.gridTopRight::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 0;
  height: 0;
}

/**

This is a "fix" to the async scroll browser behavior.

MultiGrid has the unfortunate implementation that it create multiple
scrolling containers and keeps them in sync using .scrollTop and .scrollLeft
That's fine and dandy, but browsers have decided for performance reasons that
setting .scrollTop and .scrollLeft don't trigger redraws synchronously.  The
browser gets to it when it can.

This is actually bad because it forces everything onto the compositor thread
and there is no guarantee this will continue to work long term...  So really
the scrolling is actually a bit slower, but overall appears better because
the grids always line up.

This only works for Chrome on Mac.  It doesn't fix it in Firefox, and I
don't think it fixes it on Windows...

Long term:
---------------
Realistically, we are probably going to need to fork react virtualized and
update the standard Grid to implement fixed rows/columns using cell positioning,
not multiple grids.

Or we can try some other technology like react-data-table-2

**/
.scrollfix::after {
  z-index: 100;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  will-change: transform;
  content: ' ';
}
`, "",{"version":3,"sources":["webpack://./datasets/handsontable/read-grid/read-grid.global.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;;EAEX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uDAAuD;EACvD,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oDAAoD;EACpD,oEAAoE;EACpE,6DAA6D;AAC/D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,sDAAsD;EACtD,sEAAsE;EACtE,+DAA+D;AACjE;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;EAC7D,kEAAkE;AACpE;;AAEA;EACE,+DAA+D;EAC/D,oEAAoE;AACtE;;AAEA;EACE,6DAA6D;EAC7D,kEAAkE;AACpE;;AAEA;EACE,+DAA+D;EAC/D,oEAAoE;AACtE;;AAEA;EACE,uDAAuD;EACvD,uEAAuE;EACvE,iBAAiB;AACnB;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,+DAA+D;EAC/D,uEAAuE;AACzE;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mEAAmE;EACnE,mFAAmF;AACrF;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,kEAAkE;AACpE;;AAEA;EACE,+DAA+D;EAC/D,oEAAoE;AACtE;;AAEA;EACE,6DAA6D;EAC7D,kEAAkE;AACpE;;AAEA;EACE,+DAA+D;EAC/D,oEAAoE;AACtE;;AAEA;EACE,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;;EAEE,wBAAwB;EACxB,QAAQ;EACR,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;EA0BE;AACF;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,YAAY;AACd","sourcesContent":[".read-grid .cell {\n  border: 1px solid #ccc;\n}\n\n.read-grid .last-saved-date {\n  font-size: 12px;\n  font-weight: 300;\n  color: #888;\n\n  justify-content: flex-end;\n  align-items: center;\n  display: flex;\n  padding: 0 5px;\n}\n\n.read-grid .unsaved-changes-indicator {\n  background: #01a166;\n  height: 8px;\n  width: 8px;\n  border-radius: 4px;\n  margin: 0 5px;\n  display: inline-block;\n}\n\n.read-grid .unsaved-changed-indicator.warn {\n  background: red;\n}\n\n.read-grid-cell {\n  box-shadow: 0 0 0 0.5px var(--table-border-color) inset;\n  word-break: break-all;\n  padding: 3px;\n  display: flex;\n  align-items: center;\n  background-color: white;\n  overflow: hidden;\n  user-select: none;\n}\n\n.read-grid tr:last-child(td) {\n  border-right: none;\n}\n\n.read-grid-cell.error {\n  background-color: var(--dataTableCell-error-bgColor);\n  box-shadow: 0 0 0 0.5px var(--dataTableCell-error-borderColor) inset;\n  border-left: 3px solid var(--dataTableCell-error-borderColor);\n}\n\n.read-grid-cell.error[data-nth-row-type='even'] {\n  background-color: var(--dataTableCell-error-bgColor-even);\n}\n\n.read-grid-cell.warning {\n  background-color: var(--dataTableCell-warning-bgColor);\n  box-shadow: 0 0 0 0.5px var(--dataTableCell-warning-borderColor) inset;\n  border-left: 3px solid var(--dataTableCell-warning-borderColor);\n}\n\n.read-grid-cell.warning[data-nth-row-type='even'] {\n  background-color: var(--dataTableCell-warning-bgColor-even);\n}\n\n.read-grid-cell.disabled {\n  color: #7e7e7e;\n  background-color: #e0e0e0;\n  box-shadow: 0 0 0 0.5px #bfbfbf inset;\n}\n\n.read-grid-cell.disabled[data-nth-row-type='even'] {\n  color: #828282;\n  background-color: #d1d1d1;\n  box-shadow: 0 0 0 0.5px #bfbfbf inset;\n}\n\n.read-grid-cell.error.selected {\n  border-left: 3px solid var(--dataTableCell-error-borderColor);\n  box-shadow: 0 0 0 1px var(--dataTableCell-error-borderColor) inset;\n}\n\n.read-grid-cell.warning.selected {\n  border-left: 3px solid var(--dataTableCell-warning-borderColor);\n  box-shadow: 0 0 0 1px var(--dataTableCell-warning-borderColor) inset;\n}\n\n.read-grid-cell.error.selected[data-nth-row-type='even'] {\n  border-left: 3px solid var(--dataTableCell-error-borderColor);\n  box-shadow: 0 0 0 1px var(--dataTableCell-error-borderColor) inset;\n}\n\n.read-grid-cell.warning.selected[data-nth-row-type='even'] {\n  border-left: 3px solid var(--dataTableCell-warning-borderColor);\n  box-shadow: 0 0 0 1px var(--dataTableCell-warning-borderColor) inset;\n}\n\n.read-grid-cell.selected {\n  background-color: var(--dataTableCell-selected-bgColor);\n  box-shadow: 0 0 0 0.5px var(--dataTableCell-selected-borderColor) inset;\n  border-left: none;\n}\n\n.read-grid-cell[data-nth-row-type='even'],\n.read-grid-cell[data-nth-row-type='odd-property'] {\n  background-color: var(--table-even-row-bgColor);\n}\n\n.read-grid-cell.selected[data-nth-row-type='even'],\n.read-grid-cell.selected[data-nth-row-type='odd-property'] {\n  background-color: var(--table-active-highlight-even-td-bgColor);\n  box-shadow: 0 0 0 0.5px var(--dataTableCell-selected-borderColor) inset;\n}\n\n.read-grid-cell[data-nth-row-type='even-property'] {\n  background-color: var(--table-property-row-bgColor);\n}\n\n.read-grid-cell.selected[data-nth-row-type='even-property'] {\n  background-color: var(--table-active-highlight-property-td-bgColor);\n  box-shadow: 0 0 0 0.5px var(--table-active-highlight-property-td-borderColor) inset;\n}\n\n.read-grid-cell.selected.first-selected {\n  border: 1.5px solid var(--dataTableCell-firstSelected);\n}\n\n.read-grid-cell.error.selected.first-selected {\n  border-left: 3px solid var(--dataTableCell-error-borderColor);\n  box-shadow: 0 0 0 1px var(--dataTableCell-error-borderColor) inset;\n}\n\n.read-grid-cell.warning.selected.first-selected {\n  border-left: 3px solid var(--dataTableCell-warning-borderColor);\n  box-shadow: 0 0 0 1px var(--dataTableCell-warning-borderColor) inset;\n}\n\n.read-grid-cell.error.selected.first-selected[data-nth-row-type='even'] {\n  border-left: 3px solid var(--dataTableCell-error-borderColor);\n  box-shadow: 0 0 0 1px var(--dataTableCell-error-borderColor) inset;\n}\n\n.read-grid-cell.warning.selected.first-selected[data-nth-row-type='even'] {\n  border-left: 3px solid var(--dataTableCell-warning-borderColor);\n  box-shadow: 0 0 0 1px var(--dataTableCell-warning-borderColor) inset;\n}\n\n.read-grid-cell.header {\n  background-color: var(--table-th-bgcolor);\n  display: flex;\n}\n\n.read-grid-cell.select-all-cell {\n  background: #f4f4f4;\n}\n\n.read-grid-cell.row-num-cell {\n  justify-content: center;\n  background: #f4f4f4;\n}\n\n.read-grid-cell.header div {\n  flex: 1;\n  text-align: right;\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.ReactVirtualized__Grid {\n  outline: none;\n}\n\n/* hide the scrollbars on fixed rows */\n.gridBottomLeft::-webkit-scrollbar,\n.gridTopRight::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 0;\n  height: 0;\n}\n\n/**\n\nThis is a \"fix\" to the async scroll browser behavior.\n\nMultiGrid has the unfortunate implementation that it create multiple\nscrolling containers and keeps them in sync using .scrollTop and .scrollLeft\nThat's fine and dandy, but browsers have decided for performance reasons that\nsetting .scrollTop and .scrollLeft don't trigger redraws synchronously.  The\nbrowser gets to it when it can.\n\nThis is actually bad because it forces everything onto the compositor thread\nand there is no guarantee this will continue to work long term...  So really\nthe scrolling is actually a bit slower, but overall appears better because\nthe grids always line up.\n\nThis only works for Chrome on Mac.  It doesn't fix it in Firefox, and I\ndon't think it fixes it on Windows...\n\nLong term:\n---------------\nRealistically, we are probably going to need to fork react virtualized and\nupdate the standard Grid to implement fixed rows/columns using cell positioning,\nnot multiple grids.\n\nOr we can try some other technology like react-data-table-2\n\n**/\n.scrollfix::after {\n  z-index: 100;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  will-change: transform;\n  content: ' ';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
